<template>
  <v-dialog v-model="showDialog" persistent transition="dialog-bottom-transition" width="600">
    <v-card>
      <v-container fluid>
        <template v-if="links!=null">
          <el-form :label-position="`left`" ref="form" label-width="120px">
            <el-form-item label="LINE URL">
              <el-input v-model="links.line_url" :readonly="true">
                <el-button slot="append" icon="el-icon-copy-document" @click="copy(links.line_url)"></el-button>
              </el-input>
              <div style="font-size:0.8rem;">ใช้สำหรับโปรโมทหน้าร้านค้าบน Application LINE</div>
            </el-form-item>
            <el-form-item label="External URL">
              <el-input v-model="links.link_to_liff" :readonly="true">
                <el-button
                  slot="append"
                  icon="el-icon-copy-document"
                  @click="copy(links.link_to_liff)"
                ></el-button>
              </el-input>
              <div
                style="font-size:0.8rem;"
              >ใช้สำหรับโปรโมทหน้าร้านค้าบน Facebook, Instagram และเวปไซต์</div>
            </el-form-item>
          </el-form>
        </template>
      </v-container>
      <v-card-actions>
        <el-button type="primary" class="el-btn-full" @click="close()">ปิด</el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
        
<script>
import Service from "../services";

export default {
  name: "link-dialog",
  props: {
    showDialog: { default: false },
    links: { default: null }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    copy(text) {
      this.$copyText(text).then(
        function(e) {},
        function(e) {}
      );
    }
  }
};
</script>